<template>
  <div class="invoice-manage">
    <div class="invoice-manage-tip">
      <span>温馨提示：</span>
      <span>1、请及时更新贵司可受理的服务事项及对应可开具的发票类目，以免影响客户选择贵司开展业务！</span>
      <span>2、服务事项与发票类目只允许停用，不支持编辑，请务必确认无误后再新增！</span>
      <span>3、停用服务事项与发票类目，会影响客户申请开票，请谨慎操作！</span>
    </div>
    <div class="invoice-manage-form">
      <span class="form-title">类目维护</span>
      <el-form ref="form" label-width="120px" size="small" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="服务事项" prop="serviceItemId">
              <el-select v-model="form.serviceItemId" :clearable="true" placeholder="请选择服务事项">
                <el-option v-for="(item, index) in serviceList" :key="index" :label="item.serviceItemName" :value="item.serviceItemId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发票类目名称" prop="invoiceClassName">
              <el-input placeholder="请输入发票类目名称" v-model="form.invoiceClassName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="invoiceClassStatus">
              <el-select v-model="form.invoiceClassStatus">
                <el-option v-for="(item, index) in classStatusAll" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-form-item style="margin-bottom: 0px;">
              <el-button @click="resetForm()">重置</el-button>
              <el-button type="primary" @click="submitForm()">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="invoice-manage-opea">
      <el-button size="small" @click="addService()">新增服务事项</el-button>
      <el-button size="small" @click="addInvoiceClass()">新增发票类目</el-button>
      <el-button size="small" @click="exportInfo()">导出</el-button>
    </div>
    <el-table size="small" :data="data">
      <el-table-column prop="serviceItemName" label="服务事项" width="150"> </el-table-column>
      <el-table-column prop="invoiceClassName" label="发票类目"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ getClassStatus(scope.row.invoiceClassStatus) }}
        </template>
      </el-table-column>
      <el-table-column label="新增时间">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="comfirmInvoiceTime" label="启用/停用时间" width="160">
        <template slot-scope="scope">
          {{ getFormatDate(scope.row.statusTime) }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button v-if="scope.row.invoiceClassStatus === 0" type="text" size="small" @click="hanldeInvoiceClassStatus(scope.row, 1)"
            >启用</el-button
          >
          <el-button v-else-if="scope.row.invoiceClassStatus === 1" type="text" size="small" @click="hanldeInvoiceClassStatus(scope.row, 0)"
            >停用</el-button
          >
          <el-button type="text" size="small" @click="handleInvoClassEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :current-page.sync="page.index"
      :page-size="page.size"
      :total="count"
      @current-change="handlePageChange()"
    >
    </el-pagination>

    <add-invoice-class ref="invoceRef" :serviceList="serviceList" @confirm="handleEditInvoClass"></add-invoice-class>
    <add-service-diglog ref="serviceRef" @confirm="addServiceItemReq"></add-service-diglog>
  </div>
</template>

<script>
import api from '@/api/api';
import { parseTime } from '@/utils';
import { classStatusAll } from '@/utils/enum';
import AddInvoiceClass from './components/addInvoiceClass';
import addServiceDiglog from './components/addServiceDiglog';

export default {
  name: 'invoiceApply',
  components: {
    AddInvoiceClass,
    addServiceDiglog,
  },
  created() {
    this.getServiceList();
    this.getInvoiceClassList();
  },
  data() {
    return {
      classStatusAll,
      form: {
        serviceItemId: '',
        invoiceClassName: '',
        invoiceClassStatus: -1,
      },
      serviceList: [], // 服务列表
      data: [],
      count: 0,
      page: {
        index: 1,
        size: 10,
      },
    };
  },
  methods: {
    submitForm() {
      this.page.index = 1;
      this.getInvoiceClassList();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.page.index = 1;
      this.getInvoiceClassList();
    },

    exportInfo() {},
    handlePageChange() {
      this.getInvoiceClassList();
    },
    handleEditInvoClass(data, edit) {
      if (edit) {
        this.editInvoClassReq(data);
      } else {
        this.addInvoClassReq(data);
      }
    },

    addInvoiceClass() {
      this.$refs.invoceRef.show();
    },
    addService() {
      this.$refs.serviceRef.show();
    },
    handleInvoClassEdit(data) {
      this.$refs.invoceRef.show(data);
    },

    getServiceList() {
      api
        .getServiceList()
        .then((data) => {
          this.serviceList = data;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    addServiceItemReq(data) {
      api
        .addServiceItem({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.serviceRef.close();
          this.getServiceList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    editInvoClassReq(data) {
      api
        .editInvoiceClass({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.invoceRef.close();
          this.$message({
            type: 'success',
            message: '发票类目新增成功',
          });
          this.getInvoiceClassList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    addInvoClassReq(data) {
      api
        .addInvoiceClass({
          params: {
            data,
          },
        })
        .then(() => {
          this.$refs.invoceRef.close();
          this.$message({
            type: 'success',
            message: '发票类目新增成功',
          });
          this.getInvoiceClassList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    getInvoiceClassList() {
      const params = Object.assign({}, this.page, this.form);
      params.index -= 1;

      api
        .getInvoiceClassList({
          params: {
            params,
          },
        })
        .then((res) => {
          this.data = res.data;
          this.count = res.count;
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    hanldeInvoiceClassStatus(invoiceClass, status) {
      const data = {
        invoiceClassId: invoiceClass.invoiceClassId,
        invoiceClassStatus: status,
      };
      api
        .editInvoiceClassStatus({
          params: {
            data,
          },
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: `发票类目已${status === 1 ? '启用' : '停用'}`,
          });
          this.getInvoiceClassList();
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.tip,
          });
        });
    },
    getClassStatus(status) {
      // eslint-disable-next-line arrow-parens
      const sta = this.classStatusAll.find((item) => item.value === status);
      return sta ? sta.label : '';
    },
    getFormatDate(time) {
      return time ? parseTime(new Date(time)) : '';
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-manage {
  .invoice-manage-tip {
    padding: 8px 12px;
    border: 1px solid #ffcd61;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fffcf2;
    margin-bottom: 24px;
    > span {
      display: block;
    }
  }
  .invoice-manage-form {
    border: 1px solid #ebeef5;
    padding: 16px;
    .form-title {
      font-size: 16px;
      font-weight: 700;
      color: #050505;
      display: block;
      margin-bottom: 10px;
    }
  }
  .invoice-manage-opea {
    padding: 16px 0px;
    text-align: right;
  }
  /deep/ .el-date-editor--daterange.el-input__inner {
    width: 100%;
  }
  /deep/ .el-select {
    display: block;
  }
  /deep/ .el-pagination {
    text-align: right;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/invoiceManage.vue